import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { isAppSite } from "@/helpers/site";
import { Join } from "@/pages/Join";
import { Landing } from "@/pages/Landing";
import { New } from "@/pages/New";
import { Play } from "@/pages/Play";
import { useFixVh } from "@/hooks/useFixVh";
import { Toaster } from "@/components/ui/sonner";

const App = () => {
  useFixVh();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          {/* The app's own domain opens the game; the landing page is on
              courtshuffle.com. */}
          <Route
            index
            element={
              isAppSite() ? <Navigate to="/play" replace /> : <Landing />
            }
          />
          <Route path="new" element={<New />} />
          <Route path="play" element={<Play />} />
          {/* Share links are namespaced per CourtShuffle app; /join is the
              older form, kept so earlier links still open. */}
          <Route path="cards/:slug" element={<Join />} />
          <Route path="join/:slug" element={<Join />} />
        </Route>
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
};

export default App;
